import { render } from "./SaffronLink.vue?vue&type=template&id=d73c63fe"
import script from "./SaffronLink.vue?vue&type=script&lang=js"
export * from "./SaffronLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__